import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { DswButtonModule } from '@vi-succ/design-system-web';

@Component({
  selector: 'et-login-screen',
  templateUrl: './login-screen.component.html',
  styleUrls: ['./login-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DswButtonModule, MatButtonModule, TranslateModule],
})
export class LoginScreenComponent {
  @Input() changeCatalogEnabled = true;
  @Output() loginClicked = new EventEmitter<void>();
  @Output() registerClicked = new EventEmitter<void>();
  @Output() changeCatalogClicked = new EventEmitter<void>();

  onLogin() {
    this.loginClicked.emit();
  }

  onRegister() {
    this.registerClicked.emit();
  }

  onChangeCatalog() {
    this.changeCatalogClicked.emit();
  }
}
